import { Image } from "@mantine/core";
import { useEffect, useState } from "react";

import { CarburateLoader } from "@/components/elements";
import { getImageContent } from "@/services/cars/get-car-image";
import classNames from "@/components/elements/ImageGallery/ImageGallery.module.css";

import type { Attachment } from "@/types/attachment";
import type { ImageProps } from "@mantine/core";
import type { DOMAttributes, FC } from "react";

export type LoadedImageProps = {
  hideLoader?: boolean;
  image: Attachment;
} & DOMAttributes<HTMLImageElement> &
  ImageProps;

export const LoadedImage: FC<LoadedImageProps> = ({ hideLoader = false, image, ...props }) => {
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const isLoading = !imageSrc && !hideLoader;

  useEffect(() => {
    getImageContent(image.path).then((dataURI) => {
      setImageSrc(dataURI);
    });
  }, [image.path]);

  return (
    <>
      {imageSrc && (
        <Image
          src={imageSrc}
          alt={image.name}
          className={classNames.mainImage}
          radius="md"
          fit="cover"
          {...props}
        />
      )}
      {isLoading && <CarburateLoader />}
    </>
  );
};
